var React = require('react');
var PropTypes = React.PropTypes;
var moment = require('moment');
// var Auth = require('../../resources/auth');
var request = require('superagent');
var env = require("../../utils/env");
var Helpers = require("../../utils/helpers");
var StudentRes = require("../../resources/student");
var apiDomain = env.domain.api;
// import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import { Link } from 'react-router';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import async from 'async';
import $ from 'jquery';
import '../../css/components/StudentClassEditor/ClassLevelDropdownList.css';


var AdminTypeDropdownList = React.createClass({

    getInitialState: function() {
        return {
            ifDisplayMenu: false,
            selectedValue: this.props.selectedValue,
            retrievedValue: "None" || this.props.retrievedValue,
        };
    },

    componentWillReceiveProps: function(nextProps) {
    // this.setState({})
    },
    componentDidUpdate: function(prevProps) {
        window.onbeforeunload = function() {
            return '';
        }
    },
    componentWillUnmount: function() {
        window.onbeforeunload = function() {
            return undefined;
        }
    },
    showDropdownMenu(event) {

        event.preventDefault();
        this.setState({ ifDisplayMenu: true }, () => {

            document.addEventListener('click', this.hideDropdownMenu);
        });
    },
    hideDropdownMenu() {

        this.setState({ ifDisplayMenu: false }, () => {

            document.removeEventListener('click', this.hideDropdownMenu);
        });
    },
    handleChangeClassLevel: function(event) {

        // this.setState({ retrievedValue: ""}, () => {

            event.persist();
            // this.setState({selectedValue: event.target.value}, () => {
                this.props.handleChangeClassLevel(event);
            // });
        // });
        
    },
    renderDropdownItems: function() {



        // return studentClassLevelList;
        // return (this.state.retrievedValue===cLevel) ?
        //                     <option value={cLevel} selected>{cLevel}</option>
        //                     : <option value={cLevel}>{cLevel}</option>
    },
    render: function() {
        var _this = this;
        var CLASS_LEVELS = ["None","Maths","Science"];
        var studentClassLevelList = CLASS_LEVELS.map(function(cLevel){
                        return <option value={cLevel}>{cLevel}</option>
                      });

        return (
            <div  className="dropdown">

                <select className="classLevelDropdown form-control mark-input createStudentField" onChange={_this.handleChangeClassLevel} 
                    value={_this.props.selectedValue}>
                    {studentClassLevelList}
                </select>

            </div>

        );
    },

    componentDidMount: function() {

    }
});

module.exports = AdminTypeDropdownList;




/** WEBPACK FOOTER **
 ** ./src/components/TeacherEditor/AdminTypeDropdownList.js
 **/